import { InjectionToken, StaticProvider } from '@angular/core';

import { BaseApiConfig, EndpointParserFn } from '../../models/base-api-config.model';

/**
 * Provides API configuration for collaboration related endpoints across the application.
 *
 * The `CollaborationApiConfig` is injected via `COLLABORATION_API_CONFIG`
 */

export type CollaborationApiConfig = BaseApiConfig<{
  getCollaborations: string;
  getCollaboration: EndpointParserFn;
  createCollaboration: string;
  updateCollaboration: EndpointParserFn;
  acceptCollaboration: EndpointParserFn;
  updateCollaborationStatus: EndpointParserFn;
  getBenefitTypes: string;
  generateCollaborationInvoices: EndpointParserFn;
  addCollaborationEvidence: EndpointParserFn;
  updateCollaborationEvidence: EndpointParserFn;
  deleteCollaborationEvidence: EndpointParserFn;
  recheckEvidenceCompliance: EndpointParserFn;
}>;

export const COLLABORATION_API_CONFIG = new InjectionToken<CollaborationApiConfig>('COLLABORATION_API_CONFIG');

export const provideCollaborationApiConfig = (config: CollaborationApiConfig): StaticProvider => ({
  provide: COLLABORATION_API_CONFIG,
  useValue: config,
});
